import React, { useState, useEffect } from 'react';
import Loading from '../../../component/Loading/Loading';
import PhoneInput from 'react-phone-input-2';
import { useSelector } from 'react-redux';
import AlertMsg from "../../../component/AlertMsg/AlertMsg";
import useAxiosInstance from '../../../services/useAxiosInstance';

const EditHome = ({ addressId, userId, onHide }) => {
  const axiosInstance = useAxiosInstance();
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const communityId = useSelector((state) => state.auth.communityId);
  const roleIds = useSelector(state => state.auth.roleId);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [formData, setFormData] = useState({
    addressDto: {
      activeStatus: true,
      address: '',
      addressId: 0,
      city: '',
      countryId: 0,
      stateId: 0,
      zipCode: ''
    },
    userDto: {
      activeStatus: true,
      emailId: '',
      emailIdIsVerified: true,
      firstName: '',
      isClient: true,
      lastLogin: '',
      lastName: '',
      middleName: '',
      mobileIsVerified: true,
      mobileNumber: '',
      otp: 0,
      password: '',
      roleId: 0,
      userId: 0,
      modifiedDate: '',
    }
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [newEmailId, setNewEmailId] = useState('');
  const [newUserId, setNewUserId] = useState('');
  const [selectedRole, setSelectedRole] = useState('');

  // Inline CSS to apply directly in this example
  const phoneInputStyles = `
   /* Container styling to match width */
   .phone-input-container {
     display: block;
     width: 100%;
   }

   /* Make the phone input match the address input exactly */
   .phone-input-container .react-tel-input .form-control {
     min-width: 100% !important;
     height: 42px !important;
     border-radius: 0.375rem !important;
     border-color: #D1D5DB !important;
     font-size: 0.875rem !important;
     line-height: 1.25rem !important;
     box-shadow: none !important;
     background-color: #FFFFFF !important;
   }

   /* Focus states to match the address input */
   .phone-input-container .react-tel-input .form-control:focus {
     outline: none !important;
     border-color: #3B82F6 !important;
     box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.3) !important;
   }

   /* Error state styles */
   .phone-input-container.has-error .react-tel-input .form-control {
     border-color: #EF4444 !important;
   }

   /* Flag dropdown styles to match */
   .phone-input-container .react-tel-input .flag-dropdown {
     background-color: transparent !important;
     border-color: #D1D5DB !important;
     border-right: none !important;
     border-radius: 0.375rem 0 0 0.375rem !important;
   }

   /* When input has focus, make sure dropdown border matches */
   .phone-input-container .react-tel-input .form-control:focus + .flag-dropdown {
     border-color: #3B82F6 !important;
   }

   /* When in error state, make sure dropdown border matches */
   .phone-input-container.has-error .react-tel-input .flag-dropdown {
     border-color: #EF4444 !important;
   }


 `;

  useEffect(() => {
    axiosInstance.get(`/api/public/country/getAll`)
      .then(response => setCountryData(response.data))
      .catch(error => console.error('Error fetching countries:', error));
  }, []);

  useEffect(() => {
    axiosInstance.get(`/api/public/state/getAll`)
      .then(response => setStateData(response.data))
      .catch(error => console.error('Error fetching states:', error));
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axiosInstance.get(`/api/user/getById/${userId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching user data:', error);
        return null;
      }
    };

    const fetchAddressData = async () => {
      try {
        const response = await axiosInstance.get(`/api/public/address/getOne/${addressId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching address data:', error);
        return null;
      }
    };

    const fetchData = async () => {
      setLoading(true);
      const [userData, addressData] = await Promise.all([fetchUserData(), fetchAddressData()]);
      if (userData && addressData) {
        const formDataUpdate = {
          ...formData,
          userDto: {
            activeStatus: userData.activeStatus,
            emailId: userData.emailId,
            emailIdIsVerified: userData.emailIdIsVerified,
            firstName: userData.firstName,
            isClient: userData.isClient,
            lastLogin: userData.lastLogin,
            lastName: userData.lastName,
            middleName: userData.middleName,
            mobileIsVerified: userData.mobileIsVerified,
            mobileNumber: userData.mobileNumber,
            otp: userData.otp,
            password: userData.password,
            roleId: userData.role.roleid,
            userId: userData.userId,
            modifiedDate: userData.modifiedDate,
          },
          addressDto: {
            activeStatus: addressData.activeStatus,
            address: addressData.address,
            addressId: addressData.addressId,
            city: addressData.city,
            countryId: addressData.countryId,
            stateId: addressData.stateId,
            zipCode: addressData.zipCode
          }
        };
        setNewEmailId(userData.emailId);
        setNewUserId(userData.userId);
        setSelectedCountryId(addressData.countryId);
        setFormData(formDataUpdate);
      }
      setLoading(false);
    };

    fetchData();
  }, [userId, addressId]);

  const handleInputChange = (eventOrValue, inputName) => {
    if (typeof eventOrValue === 'object') {
      const { name, value } = eventOrValue.target;
      const [section, key] = name.split('.');
      if (name === 'addressDto.countryId') setSelectedCountryId(value);

      setFormData((prevFormData) => ({
        ...prevFormData,
        [section]: {
          ...prevFormData[section],
          [key]: value
        }
      }));
    } else {
      const value = eventOrValue;
      const name = inputName;
      const [section, key] = name.split('.');
      setFormData((prevFormData) => ({
        ...prevFormData,
        [section]: {
          ...prevFormData[section],
          [key]: value
        }
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.userDto.firstName.trim()) newErrors.firstName = 'First Name is required';
    if (!formData.userDto.lastName.trim()) newErrors.lastName = 'Last Name is required';
    if (!formData.userDto.emailId.trim()) {
      newErrors.emailId = 'Email ID is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.userDto.emailId)) {
      newErrors.emailId = 'Email ID is invalid';
    }
    if (!formData.userDto.mobileNumber) {
      newErrors.mobileNumber = "Phone Number is required";
    } else if (formData.userDto.mobileNumber.length !== 10) {
      newErrors.mobileNumber = "Phone Number must be exactly 10 digits";
    }
    if (!formData.addressDto.address.trim()) newErrors.address = 'Address is required';
    if (!formData.addressDto.city.trim()) newErrors.city = 'City is required';
    if (!formData.addressDto.countryId) newErrors.countryId = 'Country is required';
    if (!formData.addressDto.stateId) newErrors.stateId = 'State is required';
    if (!formData.addressDto.zipCode.toString().trim()) {
      newErrors.zipCode = 'Zip Code is required';
    } else if (!/^\d+$/.test(formData.addressDto.zipCode.toString().trim())) {
      newErrors.zipCode = 'Zip Code must contain only numbers';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await axiosInstance.patch(`/api/user/updateUserWithAddress/${userId}/${addressId}`,
        formData,
      );

      console.log('Update Response:', response.data);

      if (roleIds === 1001 && selectedRole) {
        await handleUpdateBoardMemberRole(selectedRole);
      }

      setAlert({ visible: true, message: 'Homeowner updated successfully!', type: 'success' });
      setTimeout(() => {
        onHide();
      }, 2500);
    } catch (error) {
      console.error('Error updating data:', error);
      setAlert({ visible: true, message: 'Error updating homeowner: Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateBoardMemberRole = async (role) => {
    try {
      const response = await axiosInstance.patch(`/api/public/community/updateRole/${communityId}`,
        null,
        {
          params: {
            communityId: communityId,
            newEmailId: newEmailId,
            newUserId: newUserId,
            role: role,
          },
        }
      );

      console.log('Response:', response.data);
      setAlert({ visible: true, message: 'Community role updated successfully!', type: 'success' });
    } catch (error) {
      console.error('There was an error updating the Community role!', error);
      setAlert({ visible: true, message: 'There was an error updating the Community role!', type: 'error' });
    }
  };

  return (
    <div className="bg-gr min-h-screen ">
      <style>{phoneInputStyles}</style>
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
          <div className=" rounded-lg shadow-sm overflow-hidden mb-6">
            <form className="" onSubmit={handleSubmit}>
              <div className="flex flex-wrap gap-6 mb-6">
                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="userDto.firstName"
                    value={formData.userDto.firstName}
                    onChange={handleInputChange}
                    className={`w-full rounded-md border ${errors.firstName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="userDto.lastName"
                    value={formData.userDto.lastName}
                    onChange={handleInputChange}
                    className={`w-full rounded-md border ${errors.lastName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email ID <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    name="userDto.emailId"
                    value={formData.userDto.emailId}
                    onChange={handleInputChange}
                    readOnly
                    className={`w-full rounded-md border ${errors.emailId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50`}
                  />
                  {errors.emailId && <p className="text-red-500 text-xs mt-1">{errors.emailId}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className={`phone-input-container ${errors.mobileNumber ? "has-error" : ""}`}>
                    <PhoneInput
                      inputProps={{
                        name: "userDto.mobileNumber",
                        required: true,
                        autoFocus: false,
                        placeholder: "Enter mobile number",
                      }}
                      value={formData.userDto.mobileNumber}
                      onChange={(value) => handleInputChange(value, "userDto.mobileNumber")}
                      defaultCountry="US"
                      containerClass="phone-input-container"
                    />
                  </div>
                  {errors.mobileNumber && <p className="text-red-500 text-xs mt-1">{errors.mobileNumber}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Residential Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="addressDto.address"
                    value={formData.addressDto.address}
                    onChange={handleInputChange}
                    className={`w-full rounded-md border ${errors.address ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors.address && <p className="text-red-500 text-xs mt-1">{errors.address}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="addressDto.city"
                    value={formData.addressDto.city}
                    onChange={handleInputChange}
                    className={`w-full rounded-md border ${errors.city ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors.city && <p className="text-red-500 text-xs mt-1">{errors.city}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Country <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="countryId"
                    name="addressDto.countryId"
                    value={formData.addressDto.countryId}
                    onChange={handleInputChange}
                    className={`w-full rounded-md border ${errors.countryId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <option value="">Filter country</option>
                    {countryData.map(country => (
                      <option key={country.countryid} value={country.countryid}>{country.countryname}</option>
                    ))}
                  </select>
                  {errors.countryId && <p className="text-red-500 text-xs mt-1">{errors.countryId}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    State <span className="text-red-500">*</span>
                  </label>
                  <select
                    id="stateId"
                    name="addressDto.stateId"
                    value={formData.addressDto.stateId}
                    onChange={handleInputChange}
                    className={`w-full rounded-md border ${errors.stateId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  >
                    <option value="">Filter State</option>
                    {stateData
                      .filter(state => state.country.countryid === parseInt(selectedCountryId))
                      .map(state => (
                        <option key={state.stateid} value={state.stateid}>{state.statename}</option>
                      ))}
                  </select>
                  {errors.stateId && <p className="text-red-500 text-xs mt-1">{errors.stateId}</p>}
                </div>

                <div className="w-full md:w-[calc(50%-1.5rem)]">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Zip Code <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="addressDto.zipCode"
                    value={formData.addressDto.zipCode}
                    onChange={handleInputChange}
                    onKeyDown={(e) => {
                      const key = e.key;
                      if (
                        key === "Backspace" ||
                        key === "Tab" ||
                        key === "ArrowLeft" ||
                        key === "ArrowRight" ||
                        key === "Delete"
                      ) {
                        return;
                      }
                      if (!/^[0-9]$/.test(key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength="10"
                    className={`w-full rounded-md border ${errors.zipCode ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {errors.zipCode && <p className="text-red-500 text-xs mt-1">{errors.zipCode}</p>}
                </div>

                {roleIds === 1001 && (
                  <div className="w-full md:w-[calc(50%-1.5rem)]">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Role
                    </label>
                    <select
                      value={selectedRole}
                      onChange={handleRoleChange}
                      className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="">Select Role</option>
                      <option value={'president'}>President</option>
                      <option value={'secretary'}>Secretary</option>
                      <option value={'treasurer'}>Treasurer</option>
                    </select>
                  </div>
                )}
              </div>

              <div className="flex justify-between items-center">
                <div className="text-sm text-red-500">* indicates required field</div>
                <div className="flex gap-2">
                  <button
                    type="button"
                    className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    onClick={onHide}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditHome;